/*
 *
 * Profile reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  PASSWORD_UPDATE_SUCCESS,
  PROFILE_CONSTANT,
} from './constants';

const initialState = fromJS({
  isLoading: false,
  profileResponse: {},
  updateStatus: false,
  walletRegisterSubmit: { status: false },
  aadharRegisterSubmit: { status: false },
  cardActivate: { status: false },
});

function profileReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('profileResponse', fromJS({}))
        .set('isLoading', payload);
    case PASSWORD_UPDATE_SUCCESS:
      return state
        .set('updateStatus', payload)
        .set('isLoading', false);
    case PROFILE_CONSTANT.WALLET_REGISTER:
      return state
        .set('walletRegisterSubmit', fromJS(payload))
        .set('aadharRegisterSubmit', fromJS({ status: false }))
        .set('isLoading', false);
    case PROFILE_CONSTANT.AADHAR_REGISTER:
      return state
        .set('aadharRegisterSubmit', fromJS(payload))
        .set('isLoading', false);
    case PROFILE_CONSTANT.CARD_ACTIVATE:
      return state
        .set('cardActivate', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default profileReducer;



// WEBPACK FOOTER //
// client/containers/Profile/reducer.js